import { type FC } from "react";
import styled from "styled-components";
import { Typography } from "../typography/Typography";
import { TypographyVariant } from "../typography/Typography.interface";
import {
  IPaymentMethodProps,
  // PaymentProvider,
} from "./PaymentMethod.interface";
import {
  // Paypal,
  // MasterCard,
  // Visa,
  QuestionSimbol,
  FenaPayMethod,
  CashOtherPayMethod,
} from "../../icons";
import { PaymentProviders } from "@fena/toolkit-types";

const PaymentMethodContainer = styled.div`
  display: flex;
  align-items: center;
`;

const StyledTypography = styled(Typography)`
  margin-left: 10px;
`;

export const PaymentMethod: FC<IPaymentMethodProps> = ({ method }) => {
  const getNameByPaymentProvider = () => {
    switch (method) {
      case PaymentProviders.FENA_OB:
      case PaymentProviders.FENA_OB_QR:
      case PaymentProviders.FENA_MOBILE:
        return "Fena Open Banking";
      case PaymentProviders.FENA_STRIPE:
        return "Card";
      case PaymentProviders.CASH:
        return "Cash";
      case PaymentProviders.CARD:
        return "Card";
      case PaymentProviders.OTHER:
        return "Other";
      default:
        return "N/a";
    }
  };

  return (
    <PaymentMethodContainer>
      {/* {method === PaymentProviders.MASTER_CARD ? (
        <MasterCard />
      ) : method === PaymentProviders.PAYPAL ? (
        <Paypal />
      ) : method === PaymentProviders.VISA ? (
        <Visa />
      ) :  */}
      {method === PaymentProviders.FENA_OB ||
      method === PaymentProviders.FENA_OB_QR ||
      method === PaymentProviders.FENA_MOBILE ||
      method === PaymentProviders.FENA_STRIPE ? (
        <FenaPayMethod />
      ) : method === PaymentProviders.CASH ||
        method === PaymentProviders.CARD ||
        method === PaymentProviders.OTHER ? (
        <CashOtherPayMethod />
      ) : (
        <QuestionSimbol />
      )}
      <StyledTypography variant={TypographyVariant.BODY2}>
        {getNameByPaymentProvider()}
      </StyledTypography>
    </PaymentMethodContainer>
  );
};
